import { render } from "./LinkedInIcon.vue?vue&type=template&id=4551d530"
import script from "./LinkedInIcon.vue?vue&type=script&lang=js"
export * from "./LinkedInIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__